<section class='kick-putt-section' fxLayout='column' fxLayoutAlign='space-around center' fxLayoutGap='50px' id='kickputt'
    #kickputt>
    <div class='kick-putt-header'>
      HOW WE KICK PUTT
    </div>
    <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='space-around start'>
      <div class='kick-putt' fxLayout='column' fxLayoutGap='15px'>
        <div>
          <i class='fa fa-check-circle' style='font-size:54px'></i>
        </div>
        <div class='kick-putt-title'>
          REAL-TIME DIGITAL LEADERBOARD
        </div>
        <div class='kick-putt-text'>
          Eliminate messy spreadsheets!
        </div>
      </div>
      <div class='kick-putt' fxLayout='column' fxLayoutGap='15px'>
        <div>
          <i class='fa fa-check-circle' style='font-size:54px'></i>
        </div>
        <div class='kick-putt-title'>
          SEAMLESS LEAGUE COMMUNICATION
        </div>
        <div class='kick-putt-text'>
          Notifications, player dashboard, and automated emails.
        </div>
      </div>
      <div class='kick-putt' fxLayout='column'  fxLayoutGap='15px'>
        <div>
          <i class='fa fa-check-circle' style='font-size:54px'></i>
        </div>
        <div class='kick-putt-title'>
          FAST AND ACCURATE SCORE CALCULATOR
        </div>
        <div class='kick-putt-text'>
          No more errors!
        </div>
      </div>
      <div class='kick-putt' fxLayout='column' fxLayoutGap='15px'>
        <div>
          <i class='fa fa-check-circle' style='font-size:54px'></i>
        </div>
        <div class='kick-putt-title'>
          DIGITAL BET MANAGEMENT
        </div>
        <div class='kick-putt-text'>
          Keep your bets on the GGK mobile app.
        </div>
      </div>
    </div>
    <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

  </section>